import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Timeline } from 'antd';
import { STIcon } from 'components/Brand/Icons/STIcon';
import getBreakpointView from 'utils/getBreakpointView';
import useIsClient from 'hooks/useIsClient';

const CompanyMilestonesSection = ({ background, title, milestones, ...otherProps }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);
  const isClient = useIsClient();

  return (
    <SectionCompanyMilestones background={background} {...otherProps}>
      <div className="section-company-milestones--container">
        <h2 className="section-company-milestones--title">{title}</h2>

        <div className="section-company-milestones--content">
          {isClient && (
            <Timeline
              className="section-company-milestones--timeline"
              mode={isMobile ? 'left' : 'alternate'}
            >
              {milestones.map((milestoneItem, index) => {
                return (
                  <Timeline.Item key={index}>
                    <div className="section-company-milestones--item">
                      <div className="section-company-milestones--item-icon">
                        <hr />
                        <STIcon type={'icon-' + milestoneItem.iconType}></STIcon>
                      </div>
                      <div className="section-company-milestones--item-text">
                        <p className="section-company-milestones--item-date">
                          {milestoneItem.title}
                        </p>
                        <p className="section-company-milestones--item-description">
                          {milestoneItem.description}
                        </p>
                      </div>
                    </div>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          )}
        </div>
      </div>
    </SectionCompanyMilestones>
  );
};

CompanyMilestonesSection.propTypes = {
  title: PropTypes.string,
  milestones: PropTypes.array,
};

const SectionCompanyMilestones = styled.div`
  background: ${props => props.background};

  .section-company-milestones--container {
    padding: 96px 28px 144px;
    margin: 0 auto;

    .section-company-milestones--title {
      font-weight: 900;
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--normal-title-color);
    }

    .section-company-milestones--content {
      max-width: 920px;
      padding: 0;
      margin: 100px auto 0;

      .section-company-milestones--timeline {
        .section-company-milestones--item {
          display: flex;
          align-items: start;

          .section-company-milestones--item-icon {
            height: 32px;
            display: flex;

            hr {
              width: 27px;
              margin: 10px 10px 10px 8px;
              border-style: dashed;
              border-width: 1px;
              border-color: #cfd8dc;
            }

            .st-icon-wrapper {
              width: 32px;
              height: 32px;
              min-width: 32px;
              margin-top: -6px;
              margin-right: 13px;

              img {
              }
            }
          }

          .section-company-milestones--item-text {
            .section-company-milestones--item-date {
              font-weight: bold;
              font-size: 20px;
              line-height: 120%;
              letter-spacing: -0.01em;
              color: var(--normal-description-color);
              margin: 0;
            }

            .section-company-milestones--item-description {
              font-weight: 500;
              font-size: 16px;
              line-height: 150%;
              color: var(--normal-description-color);
              margin: 10px 0 0;
            }
          }
        }

        .ant-timeline-item-right {
          .section-company-milestones--item {
            flex-direction: row-reverse;

            .section-company-milestones--item-icon {
              flex-direction: row-reverse;

              .st-icon-wrapper {
                margin-left: 13px;
                margin-right: 0;

                img {
                }
              }
            }
          }
        }
      }

      .section-company-milestones--next-button {
        font-weight: bold;
        font-size: 20px;
        line-height: 120%;
        text-align: center;
        letter-spacing: -0.01em;
        color: var(--normal-description-color);
        cursor: pointer;
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-company-milestones--container {
      padding: 48px 28px;

      .section-company-milestones--title {
        font-size: 29px;
        letter-spacing: -0.03em;
      }

      .section-company-milestones--content {
        max-width: 606px;
        margin-top: 65px;
        padding: 0;

        .section-company-milestones--timeline {
          .section-company-milestones--item {
            .section-company-milestones--item-text {
              .section-company-milestones--item-date {
                font-size: 18px;
              }

              .section-company-milestones--item-description {
                font-size: 16px;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
  }

  .ant-timeline {
    width: 100%;

    .ant-timeline-item-tail {
      border-left: 1px solid var(--blue-7);
    }

    .ant-timeline-item-head {
      background: var(--blue-5);
      border: 2px solid var(--white-color);
      width: 16px;
      height: 16px;
      margin-left: -7px !important;
      margin-top: -3px;
    }
  }

  @media (max-width: 576px) {
    .ant-timeline {
      .ant-timeline-item-head {
        margin-left: -3px !important;
      }
    }
  }
`;

export default CompanyMilestonesSection;
